// http://localhost:3000/kms-front/#/mobile/mobile-auth/token/kpi/ru/
export const MOBILE_ROUTES = {
  mobileAuth: "mobile/mobile-auth/:tokenId?/:pathId?/:locale?/:requestId?",

  education: "mobile/education/my-education",
  learning_history: "mobile/education/learning-history",
  course: "mobile/education/course",
  rating_students: "mobile/education/rating-students",
  calendar: "mobile/education/MyCalendar",
  training_plan: "mobile/education/trainingPlan",
  book: "mobile/education/book",
  bookItem: "mobile/education/book/:entityId?",
  courseItem: "mobile/education/course/:entityId",
  courseItemId: "mobile/education/course/:entityId/:courseScheduleId",
  myCourse: "mobile/education/my-course",
  myCourseItem: "mobile/education/my-course/:entityId",
  myCourseManagment: "mobile/education/my-course/:entityId?/:homework?",
  course_schedule: "mobile/education/courseScheduleList",

  absenceBalance: "mobile/absence/balance",

  organizationVacancyList: "mobile/vacancy/OrganizationVacancyList",
  organizationVacancyListId: "mobile/vacancy/OrganizationVacancyList/:entityId",
  organizationVacancyRecommendId:
    "mobile/vacancy/OrganizationVacancyRecommend/:entityId",
  organizationVacancyRespondId:
    "mobile/vacancy/OrganizationVacancyRespond/:entityId",

  orderChangeRequest: "mobile/request/orderChangeRequest/:entityId?",
  orderRegisterSheet: "mobile/request/orderRegisterSheet/:entityId?",
  registerOrderRequestItem: "mobile/request/registerOrderRequest/:entityId?",
  registerOrderRequest: "mobile/request/registerOrderRequest",

  jobDescriptionList: "mobile/request/JobDescriptionList",
  jobDescriptionRequest: "mobile/request/jobDescriptionRequest/:entityId?",

  personAssignmentList: "mobile/profile/experience",
  nutritionBalance: "mobile/profile/nutritionBalance",

  // kpi
  kpiList: "mobile/kpi/kpiList",
  kpiListPerson: "mobile/kpi/kpiList/:personGroupId?",
  kpiListManager: "mobile/kpi/kpiListManager",
  kpiItem: "mobile/kpi/kpiItem/:entityId?",
  kpiAnalytics: "mobile/kpi/kpiAnalytics/:personGroupId?",


  // feedbackQuestions
  portalFeedbackQuestionsList: "mobile/feedbackQuestions/my-portal-feedback-questions",
  portalIncomingFeedbackQuestions: "mobile/feedbackQuestions/incoming-feedback-questions",
  portalQuestionsItem: "mobile/feedbackQuestions/questions-item/:entityId?",
};

type RouteItem = {
  mobile: string;
  desktop: string;
  name?: string;
  label?: string;
  headerLabel?: string;
};

type ROUTES_TYPE = Record<string, RouteItem>;


export const ROUTES: ROUTES_TYPE = {
  education: {
    mobile: MOBILE_ROUTES.education,
    desktop: "my-education",
  },
  learning_history: {
    mobile: MOBILE_ROUTES.learning_history,
    desktop: "learning-history",
  },
  course: {
    mobile: MOBILE_ROUTES.course,
    desktop: "course",
  },
  rating_students: {
    mobile: MOBILE_ROUTES.rating_students,
    desktop: "rating-students",
  },
  calendar: {
    mobile: MOBILE_ROUTES.calendar,
    desktop: "MyCalendar",
  },
  training_plan: {
    mobile: MOBILE_ROUTES.training_plan,
    desktop: "trainingPlan",
  },
  book: {
    mobile: MOBILE_ROUTES.book,
    desktop: "book",
  },
  bookItem: {
    mobile: MOBILE_ROUTES.book,
    desktop: "book/:entityId?",
  },
  courseItem: {
    mobile: MOBILE_ROUTES.courseItem,
    desktop: "course/:entityId",
  },
  courseItemId: {
    mobile: MOBILE_ROUTES.courseItemId,
    desktop: "course/:entityId/:courseScheduleId",
  },
  myCourse: {
    mobile: MOBILE_ROUTES.myCourse,
    desktop: "my-course",
  },
  myCourseItem: {
    mobile: MOBILE_ROUTES.myCourseItem,
    desktop: "my-course/:entityId",
  },
  mobileAuth: {
    mobile: MOBILE_ROUTES.mobileAuth,
    desktop: "mobile-auth/:tokenId?/:pathId?/:locale?",
  },
  course_schedule: {
    mobile: MOBILE_ROUTES.course_schedule,
    desktop: "courseScheduleList",
  },
  personAssignmentList: {
    mobile: MOBILE_ROUTES.personAssignmentList,
    desktop: "profile/experience",
  },
  absenceBalance: {
    mobile: MOBILE_ROUTES.absenceBalance,
    desktop: "absence/balance",
  },
  orderChangeRequest: {
    mobile: MOBILE_ROUTES.orderChangeRequest,
    desktop: "orderChangeRequest/:entityId?",
  },
  registerOrderRequest: {
    mobile: MOBILE_ROUTES.registerOrderRequestItem,
    desktop: "registerOrderRequest/:entityId?",
  },
  orderRegisterSheet: {
    mobile: MOBILE_ROUTES.orderRegisterSheet,
    desktop: "orderRegisterSheet/:entityId?",
  },

  nutritionBalance: {
    mobile: MOBILE_ROUTES.nutritionBalance,
    desktop: "nutritionBalance",
  },

  // kpi
  kpiList: {
    mobile: MOBILE_ROUTES.kpiList,
    desktop: "kpi",
    name: "menu.my-kpi",
    label: "menu.my-kpi",
  },
  kpiListPerson: {
    mobile: MOBILE_ROUTES.kpiListPerson,
    desktop: "kpi",
    name: "[fullName]",
    label: "menu.my-kpi",
  },
  kpiListManager: {
    mobile: MOBILE_ROUTES.kpiListManager,
    desktop: "kpi-team",
    name: "menu.team-kpi",
    label: "menu.team-kpi",
  },
  kpiItem: {
    mobile: MOBILE_ROUTES.kpiItem,
    desktop: "kpi/:entityId?",
    name: "[performancePlanName]",
    label: "",
  },
  kpiAnalytics: {
    mobile: MOBILE_ROUTES.kpiAnalytics,
    desktop: "#",
    name: "[fullName]",
    headerLabel: "kpi.analytics",
    label: "kpi.analytics",
  },


  // jobDescription
  jobDescriptionList: {
    mobile: MOBILE_ROUTES.jobDescriptionList,
    desktop: "jobDescriptionList",
  },
  jobDescriptionRequest: {
    mobile: MOBILE_ROUTES.jobDescriptionRequest,
    desktop: "jobDescriptionRequest/:entityId?",
  },

  // feedbackQuestions
  portalFeedbackQuestionsList: {
    mobile: MOBILE_ROUTES.portalFeedbackQuestionsList,
    desktop: "my-feedback-questions",
  },
  portalIncomingFeedbackQuestions: {
    mobile: MOBILE_ROUTES.portalIncomingFeedbackQuestions,
    desktop: "incoming-feedback-questions",
  },
  portalQuestionsItem: {
    mobile: MOBILE_ROUTES.portalQuestionsItem,
    desktop: "questions-item/:entityId?",
  },
};
